interface Props {
  pageIndex: number
  onShowPageMetadata: (pageIndex: number) => void
}

export default function usePageThumbnailMetadata({ pageIndex, onShowPageMetadata }: Props) {
  const buttonRef = document.createElement('button')

  buttonRef.addEventListener('click', (event) => {
    event.stopPropagation()
    onShowPageMetadata(pageIndex)
  })

  buttonRef.className = 'c-file-viewer-thumbnail-metadata__button'

  const imgMetadata = document.createElement('img')

  imgMetadata.src = '/assets/v-metadata_icon.svg'
  imgMetadata.alt = 'Show metadata'

  buttonRef.innerHTML = ''
  buttonRef.appendChild(imgMetadata)

  return {
    node: buttonRef,
  }
}
